import {Component, Input, OnInit, ViewEncapsulation} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import Chart from 'chart.js';
import {AnalyticsService} from "../../../services/analytics/analytics.service";
import {TotalSalesReportModel} from "../../../model/analytics/total-sales-report.model";
import {AlertService} from "../../../services/alert/alert.service";

@Component({
  selector: "app-analytics-total-sales",
  templateUrl: "analytics-total-sales.component.html",
  styleUrls: ["./analytics-total-sales.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AnalyticsTotalSalesComponent implements OnInit {

  @Input() businessId: string;

  public canvas : any;
  public ctx;
  public datasets: any;
  public myChartData;
  public isChartFirstLoad = true;

  public totalSales = 0;

  public loadingData: boolean;

  startDateModel;
  endDateModel;

  gradientChartOptionsConfigurationWithTooltipRed: any = {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    tooltips: {
      backgroundColor: '#f5f5f5',
      titleFontColor: '#333',
      bodyFontColor: '#666',
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest"
    },
    responsive: true,
    scales: {
      yAxes: [{
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.0)',
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9a9a9a"
        }
      }],

      xAxes: [{
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(233,32,16,0.1)',
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a"
        }
      }]
    }
  };

  constructor(private alertService: AlertService,
              private translate: TranslateService,
              private analyticsService: AnalyticsService) {}

  ngOnInit() {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    this.startDateModel = oneWeekAgo;
    this.endDateModel = new Date();

    this.getTotalSalesReportData();
    // this.populateChartData([], [], true);
  }

  public getTotalSalesReportData(displaySuccessMessage?: boolean) {
    this.loadingData = true;
    this.analyticsService.getTotalSales(this.businessId,
      this.analyticsService.getDateAsString(this.startDateModel), this.analyticsService.getDateAsString(this.endDateModel)).subscribe(
      next => {
        this.loadingData = false;
        if (next && next._body) {
          const totalSalesReport: TotalSalesReportModel = JSON.parse(next._body);
          const chartDayLabels: string[] = [];
          const datasetValues: number[] = [];
          for (const property in totalSalesReport.totalSalesByDay) {
            chartDayLabels.push(property);
            datasetValues.push(totalSalesReport.totalSalesByDay[property] / 100);
          }
          this.totalSales = totalSalesReport.totalSales / 100;
          this.populateChartData(chartDayLabels, datasetValues);
          if (displaySuccessMessage) {
            this.alertService.toastSuccess(this.translate.instant("page.dashboard.analytics.totalSales.message.loadSuccess"));
          }
        } else {
          this.alertService.toastError(this.translate.instant("page.dashboard.analytics.totalSales.message.loadFail"));
          console.error(this.translate.instant("page.dashboard.analytics.totalSales.message.loadFail") + " Error: " + JSON.stringify(next));
        }
      }, error => {
        this.loadingData = false;
        this.alertService.toastError(this.translate.instant("page.dashboard.analytics.totalSales.message.loadError"));
        console.error(this.translate.instant("page.dashboard.analytics.totalSales.message.loadFail") + " Error: " + JSON.stringify(error));
      }
    );
  }

  onStartDateChanged() {
    this.isChartFirstLoad = false;
    this.getTotalSalesReportData(true);
  }

  onEndDateChanged() {
    this.isChartFirstLoad = false;
    this.getTotalSalesReportData(true);
  }

  /**
   * Chart data initialization
   */
  private populateChartData(chartDayLabels: string[], datasetValues: number[], isMock?: boolean) {
    if (isMock) {
      chartDayLabels = ['20 APR', '21 APR', '22 APR', '23 APR', '24 APR', '25 APR', '26 APR'];
      datasetValues = [1060, 875, 1760, 2090, 1080, 1110, 2100];
    }

    if (this.isChartFirstLoad) {
      this.canvas = document.getElementById("lineChartTotalSales");
      this.ctx = this.canvas.getContext("2d");

      const gradientStroke = this.ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke.addColorStop(1, 'rgba(233,32,16,0.2)');
      gradientStroke.addColorStop(0.4, 'rgba(233,32,16,0.0)');
      gradientStroke.addColorStop(0, 'rgba(233,32,16,0)'); // red colors

      const config = {
        type: 'line',
        data: {
          labels: chartDayLabels,
          datasets: [{
            label: this.translate.instant('page.dashboard.analytics.totalSales.dataset.dailySale'),
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: '#ec250d',
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: '#ec250d',
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: '#ec250d',
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: datasetValues,
          }]
        },
        options: this.gradientChartOptionsConfigurationWithTooltipRed
      };
      this.myChartData = new Chart(this.ctx, config);

    } else {
      this.myChartData.chart.data.labels = chartDayLabels;
      this.myChartData.chart.data.datasets[0].data = datasetValues;
      this.myChartData.chart.update();
    }
  }
}
